module.exports = __webpack_public_path__ + "static/media/vector.1b930ef4.svg";